export default "__VITE_ASSET__DXvDcKI3__"